// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"dc03d79d","796":"e5ad5527"}[chunkId] + ".chunk.js";
};